import * as React from 'react'
import {
  DriverContractsPage,
  DriverViolationsPage,
  DriverBusinessTripsPage,
  DriverTimesheetPage,
  DriverSchedulePage,
  DriverGroupContractsPage,
  DriverGroupViolationsPageNew,
  DriverGroupBusinessTripsPage,
  DriverGroupChartDetailsPage,
  DriverGroupTimesheetPage,
  DriverGroupTimesheetBonusAndRewardsPage,
  DriverActivitiesPage,
  DriverGroupBusinessTripNewPage,
  DriverBusinessTripEditPage,
} from './pages'

import { AppRoute } from './types'
import DriverViewControlBarWithDate from './shared/viewBars/DriverActivityBarWithDate'
import DriversViewControlBar from './shared/viewBars/DriversViewControlBar'
import DriverViewControlBarClear from './shared/viewBars/DriverViewControlBarClear'
import DriversGroupTmesheetControlBar from './shared/viewBars/DriversGroupTmesheetControlBar'
import ChartDetailsGroupControlBar from './shared/viewBars/ChartDetailsGroupControlBar'

import { DriverForeignAmountsPreview } from './pages/DriverForeignAmountsPreview'
import { driversRoutesMap } from './routes-config'
import { TopBarGroupContainer } from './shared/viewBars/TopBarGroupContainer'
import { DriverViolationsPageNew } from './pages/DriverViolationsPageNew'

export { driversRoutesMap }

export const driversRoutes: AppRoute[] = [
  {
    path: driversRoutesMap.driverContracts,
    component: DriverContractsPage,
    navigation: true,
    heightScreen: true,
    viewControlBar: () => <DriverViewControlBarClear />,
  },

  {
    path: driversRoutesMap.driverActivities,
    component: DriverActivitiesPage,
    heightScreen: true,
    navigation: false,
    hideSidePanel: true,
  },
  {
    path: driversRoutesMap.driverViolations,
    component: DriverViolationsPage,
    navigation: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  {
    path: driversRoutesMap.driverBusinessTrips,
    component: DriverBusinessTripsPage,
    navigation: true,
    heightScreen: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  // {
  //   path: driversRoutesMap.driverBusinessTripNew,
  //   component: DriverBusinessTripNewPage,
  //   navigation: false,
  // },
  {
    path: driversRoutesMap.driverBusinessTripEdit,
    component: DriverBusinessTripEditPage,
    navigation: false,
  },
  {
    path: driversRoutesMap.driverTimesheet,
    component: DriverTimesheetPage,
    heightScreen: true,
    navigation: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  {
    path: driversRoutesMap.driverSchedule,
    component: DriverSchedulePage,
    navigation: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  {
    path: driversRoutesMap.driverGroupContracts,
    component: DriverGroupContractsPage,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <DriversViewControlBar />,
  },

  {
    path: `/et/company/:companyId/driverModule/violations-new`,
    component: DriverGroupViolationsPageNew,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  // {
  //   path: `/et/company/:companyId/driverModule/violations-new/from/:from/to/:to`,
  //   component: DriverGroupViolationsPageNew,
  //   heightScreen: true,

  //   navigation: true,
  //   viewControlBar: () => (
  //     <ActivityProvider>
  //       <DriverViewControlBarWithDate />
  //     </ActivityProvider>
  //   ),
  // },
  {
    path: `/et/company/:companyId/driverModule/driver/:driverId/violation-new/from/:from/to/:to`,
    component: DriverViolationsPageNew,
    heightScreen: true,

    navigation: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  {
    path: driversRoutesMap.driverGroupBusinessTrips,
    component: DriverGroupBusinessTripsPage,
    navigation: true,
    heightScreen: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  {
    path: driversRoutesMap.driverGroupChartDetails,
    component: DriverGroupChartDetailsPage,
    navigation: true,
    heightScreen: true,
    viewControlBar: () => <ChartDetailsGroupControlBar />,
  },
  {
    path: driversRoutesMap.driverGroupBusinessTripNew,
    component: DriverGroupBusinessTripNewPage,
    heightScreen: true,
    navigation: false,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
  {
    path: driversRoutesMap.driverGroupTimesheetBonusAndRewards,
    component: DriverGroupTimesheetBonusAndRewardsPage,
    navigation: true,
    heightScreen: true,
    viewControlBar: () => (
      <TopBarGroupContainer
        singleRoute={driversRoutesMap.driverTimesheet}
        displayMonthPicker
      />
    ),
  },
  {
    path: driversRoutesMap.driverGroupTimesheet,
    heightScreen: true,
    component: DriverGroupTimesheetPage,
    navigation: true,
    viewControlBar: () => <DriversGroupTmesheetControlBar />,
  },

  {
    path: driversRoutesMap.driverForeignAmountsPreview,
    component: DriverForeignAmountsPreview,
    navigation: true,
    viewControlBar: () => <DriverViewControlBarWithDate />,
  },
]
